import { ScoreFactor } from "@inrange/building-manager-api-client/models-site";
import styled from "styled-components";
import { ScoreTooltipOrgContext } from "../utils/buildScoreTooltipText";
import { inrangeScoreStatusColor } from "../utils/siteScoresData";
import { siteStatusMap } from "../utils/siteStatusConstants";
import SiteScoreWithInfo from "./SiteScoreWithInfo";

const SiteStatus = ({
  score,
  scoreFactors,
  scoreOrgContext,
  siteStatus,
  siteOperationalDate,
}: {
  score?: number;
  scoreFactors?: ScoreFactor[];
  scoreOrgContext: ScoreTooltipOrgContext;
  siteStatus?: string;
  siteOperationalDate?: string | null;
}) => {
  if (siteStatus?.startsWith("operational")) {
    return null;
  }

  return (
    <StatusContainer>
      {siteStatus === "notStarted" ? (
        score && (
          <SiteScoreWithInfo
            siteScore={score}
            statusColor={inrangeScoreStatusColor[score]}
            scoreFactors={scoreFactors}
            scoreOrgContext={scoreOrgContext}
            tooltipPosition="bottom"
          />
        )
      ) : (
        <>
          {siteStatus && (
            <StatusBox>
              {siteStatusMap[siteStatus].map((text, index) => (
                <span key={index}>{text}</span>
              ))}
            </StatusBox>
          )}
          {siteOperationalDate &&
            new Date(siteOperationalDate) > new Date() && (
              <StatusBox>
                <span>Est. operational</span>
                <span>
                  {new Date(siteOperationalDate).toLocaleString("default", {
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              </StatusBox>
            )}
        </>
      )}
    </StatusContainer>
  );
};

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const StatusBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  font-size: 14px;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-left: 10px;
  border-radius: 8px;
  border: none;
  width: 160px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.grey200};
`;

export default SiteStatus;
